/* FITINY 国家选择器搜索：纯前端过滤，不发请求 */
(function () {
  if (window.__fitinyCountrySearch) return;
  window.__fitinyCountrySearch = true;
  document.addEventListener('input', function (e) {
    var input = e.target.closest('[data-country-search]');
    if (!input) return;
    var pfx = input.getAttribute('data-country-search');
    var list = document.querySelector('[data-country-list="' + pfx + '"]');
    if (!list) return;
    var q = input.value.trim().toLowerCase();
    var shown = 0;
    list.querySelectorAll('button[data-country-name]').forEach(function (btn) {
      var hit = !q || btn.getAttribute('data-country-name').indexOf(q) !== -1;
      btn.hidden = !hit;
      if (hit) shown++;
    });
    var empty = document.querySelector('[data-country-empty="' + pfx + '"]');
    if (empty) empty.hidden = shown !== 0;
  });
})();
